import React from 'react';
import memoizeOne from 'memoize-one';
import SimpleActions from './SimpleActions';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';

const columns = memoizeOne((handleClick, onlyShow) => [
  {
    name: 'Trabajador',
    selector: 'full_name',
    id: 'full_name',
    cell: item => {
      return (
        <div className="d-flex flex-column" role="presentation">
          <span data-tag="allowRowEvents">{item?.full_name}</span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.national_identification || item?.nationalIdentification}
          </span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.start_date_contract ? `(${item?.start_date_contract})` : null}
          </span>
        </div>
      );
    },
    grow: '1',
    sortable: true
  },
  {
    name: 'Monto',
    selector: 'parsed_assets',
    id: 'parsed_assets',
    grow: '1',
    sortable: true
  },
  {
    name: 'Retención',
    selector: 'parsed_retention',
    id: 'parsed_retention',
    grow: '1',
    sortable: true
  },
  {
    name: 'Liquido',
    selector: 'parsed_liquid',
    id: 'parsed_liquid',
    grow: '1',
    sortable: true
  },
  {
    name: 'Acciones',
    selector: 'actions',
    cell: item => (
      <SimpleActions handleClick={handleClick} item={camelCaseEmptyStringRecursive(item)} onlyShow={onlyShow} />
    ),
    id: 'actions',
    grow: '1'
  }
]);

export default columns;
